import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/api/client';
import { STRICT_PASSWORD_POLICY, type PasswordPolicy } from '@lognai/plugin-sdk';

/**
 * The password rules the server actually enforces.
 *
 * Deployment configuration (local development relaxes them), so it is fetched
 * once and cached for the session. Every password form reads it, instead of
 * each carrying its own guess at the rules (QA ledger AUTH-008).
 *
 * Falls back to the STRICT policy while loading and on failure: a form that
 * guesses should refuse a password the server would take, never accept one it
 * will reject.
 */
export function usePasswordPolicy(): PasswordPolicy {
  const { data } = useQuery({
    queryKey: ['auth', 'password-policy'],
    queryFn: async () => {
      const response = await apiClient.get<{ success: boolean; data: PasswordPolicy }>(
        '/api/auth/password-policy'
      );
      return response.data.data;
    },
    staleTime: Infinity,
    retry: false,
  });
  return data ?? STRICT_PASSWORD_POLICY;
}
